import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import FullPageSpinner from '@t7x000/apex-web/lib/components/common/FullPageSpinner/FullPageSpinner.js';
import path from '../helpers/path';
import VerifyEmailContainer from '@t7x000/apex-web/lib/components/VerifyEmail/VerifyEmailContainer';
import ResetPasswordFormContainer from '@t7x000/apex-web/lib/components/ResetPasswordForm/ResetPasswordFormContainer';
import ConfirmWithdrawContainer from '@t7x000/apex-web/lib/components/ConfirmWithdraw/ConfirmWithdrawContainer';
import DepositConfirmationModalContainer from '@t7x000/apex-web/lib/components/DepositConfirmation/DepositConfirmationModalContainer';
import VerifyAddressContainer from '@t7x000/apex-web/lib/components/VerifyAddress/VerifyAddressContainer';
import VerifyDeviceContainer from '@t7x000/apex-web/lib/components/VerifyDevice/VerifyDeviceContainer';
import {
  checkForVerifyEmailParam,
  checkForResetPassParam,
  checkForConfirmWithdrawParam,
  checkForDepositConfirmationParam,
  checkForLoginParam,
  checkForVerifyDeviceParam,
} from '@t7x000/apex-web/lib/helpers/emailLinksHelper';
import { checkForVerifyAddressParam } from '@t7x000/apex-web/lib/helpers/homePageLayoutHelper';

const RedirectWithLoaderPage = ({ pendingAuth, isAuthenticated, isAuthenticating }) => {
  if (pendingAuth || (!isAuthenticated && isAuthenticating)) {
    return (
      <div>
        <FullPageSpinner pastDelay isVisible />
      </div>
    );
  }

  if (checkForVerifyEmailParam()) {
    return <VerifyEmailContainer />;
  } else if (checkForConfirmWithdrawParam()) return <ConfirmWithdrawContainer />;
  else if (checkForResetPassParam()) return <ResetPasswordFormContainer />;
  else if (checkForDepositConfirmationParam()) return <DepositConfirmationModalContainer />;
  else if (checkForLoginParam()) return <Redirect to={path('/login')} />;
  else if (checkForVerifyAddressParam()) return <VerifyAddressContainer />;
  else if (checkForVerifyDeviceParam()) return <VerifyDeviceContainer />;
  else {
    if (!isAuthenticated) {
      return <Redirect to={path('/login')} />;
    } else {
      return <Redirect to={path('/dashboard')} />;
    }
  }
};

const mapStateToProps = (state) => ({
  isAuthenticating: !!localStorage.getItem('token'),
  isAuthenticated: state.auth.isAuthenticated,
  pendingAuth: state.auth.pending,
});

export default connect(mapStateToProps)(RedirectWithLoaderPage);
